<mat-form-field [ngClass]="classes" class="select-filter override-hide-placeholder" [matTooltip]=getTooltip()
  [matTooltipShowDelay]="1100">
  <mat-label>{{label}}</mat-label>
  <mat-select #filterSelect multiple
    [panelClass]="'select-search-dropdown-panel ' + panelClass"
    (selectionChange)="emitConstantChangedComplete($event.value);"
    (click)="$event.stopPropagation()"
    (openedChange)="onOpen($event)"
    [compareWith]="filter_compare || compareByName"
    [allowFit]="allow_fit"
    [appFitContent]="app_fit_content"
    [ngStyle]="conditional_formats || formats?.style"
    [tabindex]="tab_index"
    [placeholder]="getPlaceholder()"
    [value]="modelValue"
    [disabled]="disabled"
    data-testid="required-component-type-columns"
    >
    <mat-select-trigger>
      <span class="additional-selection">{{getPlaceholder()}}
      </span>
    </mat-select-trigger>
    <div class="dropdown-container">
      @if (options?.length > 5) {
        <ng-container class="row center sticky">
          <option-list-search (keydown.space)="$event.stopPropagation()"
            [placeholder]="'Search ' + (listType ?? '')"
            [selectElementRef]="filterSelect"
            (inputChanged)="filterOptionList($event)"
            (inputCleared)="onClear()"
            [delay]="300">
          </option-list-search>
        </ng-container>
      }
      @if (filteredOptions?.length === 0) {
        <div class="row error">
          <span>"{{errorMessage}}"</span>
        </div>
      }
      @for (option of filteredOptions; track $index) {
        <ng-container class="row options">
          @if (option?.name && option?.value) {
            <mat-option
              [value]="option.value" [disabled]="disableItemFunction(option)">{{stringFunction(option) | upperfirst}}
            </mat-option>
          } @else {
            <mat-option [value]="option"
              [disabled]="disableItemFunction(option)">{{stringFunction(option) | upperfirst | removeUnderscore}}
            </mat-option>
          }
        </ng-container>
      }
    </div>
    <!-- Selected values with no matching option. Outside the container above so they cannot
         skew the search-bar threshold, the filter, or the empty-list message.
         Tracked by the stored value: two stored values can share one display label, so the
         label is not a key. -->
    @for (orphan of orphanedOptions; track orphan.value) {
      <mat-option class="select-filter-orphaned-option"
                  [value]="orphan.value"
                  [attr.aria-label]="orphan.name + ', no longer an option'"
                  disabled>
        {{ orphan.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
